import { TablePlugin as LexicalTablePlugin } from '@lexical/react/LexicalTablePlugin';

import { TableActionMenuPlugin } from './TableActionMenuPlugin';
import { TableColumnResizerPlugin } from './TableColumnResizerPlugin';
import { TableHoverActionsPlugin } from './TableHoverActionsPlugin';

/**
 * Tables plus Froala-style editing: the cell menu, edge "+" buttons and column resizing.
 * - Rich mode only (see the registry): plain values would flatten a table to bare cell text.
 */
export const TablePlugin = () => (
  <>
    <LexicalTablePlugin hasNestedTables />
    <TableActionMenuPlugin />
    <TableHoverActionsPlugin />
    <TableColumnResizerPlugin />
  </>
);
